import Constants from '../../../services/Constants';

// same display as the planning management: a free half-day is shown as open whatever its remaining slots
const HALF_DAY_CLASSES = {
  'blocked-open': 'block-am-open-pm',
  'open-blocked': 'open-am-block-pm',
  'blocked-closed': 'block-am-close-pm',
  'closed-blocked': 'close-am-block-pm',
  'open-closed': 'open-am-close-pm',
  'closed-open': 'close-am-open-pm',
  'blocked-norental': 'block-am-no-rental-pm',
  'norental-blocked': 'no-rental-am-block-pm',
  'closed-norental': 'close-am-no-rental-pm',
  'norental-closed': 'no-rental-am-close-pm',
  'blocked-blocked': 'calendar-box--unavailable',
  'closed-closed': 'calendar-box--closed',
};

const HalfDayStatus = {

  // For DUI users, the backend keeps the slots of blocked half-days and reports the day as OPEN,
  // so the half-day statuses are used to display the day as the planning management does.
  // A half-day blocked for waiting (or non-waiting) customers only is shown as open for the other ones, as the backend does for customers.
  // The rental availability is known for the whole day, so all the open half-days are shown as without rental when there is none.
  // Returns null when the half-day statuses do not decide the display
  computeColor({amStatus, amExtendedStatus, pmStatus, pmExtendedStatus}, waiting, rentalAvailable = true) {
    if (!amStatus && !pmStatus) {
      return null;
    }
    const open = rentalAvailable ? 'open' : 'norental';
    const am = this.state(amStatus, amExtendedStatus, waiting, open, Constants.DAY_CLOSED_AM, Constants.DAY_BLOCK_AM, Constants.DAY_CONSTRAINT_BLOCK_WAIT_AM, Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_AM);
    const pm = this.state(pmStatus, pmExtendedStatus, waiting, open, Constants.DAY_CLOSED_PM, Constants.DAY_BLOCK_PM, Constants.DAY_CONSTRAINT_BLOCK_WAIT_PM, Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_PM);
    return HALF_DAY_CLASSES[`${am}-${pm}`] || null;
  },

  state(status, extendedStatus, waiting, open, closed, blocked, blockWait, blockNonWait) {
    if (status === closed.value) {
      return 'closed';
    }
    if (status !== blocked.value) {
      return open;
    }
    if (!extendedStatus) {
      return 'blocked'; // blocked for all
    }
    const appliesToIntervention = (extendedStatus === blockWait.value && waiting) || (extendedStatus === blockNonWait.value && !waiting);
    return appliesToIntervention ? 'blocked' : open;
  },

  // same rule as the backend availabilities (MobilityType.WAIT_AT_DEALERSHIP)
  isWaiting(intervention) {
    const {journey: {properties: {mobility: {mobility} = {}} = {}} = {}} = intervention || {};
    return !!mobility && mobility.name === Constants.MOBILITY_WAIT;
  },
};

export default HalfDayStatus;
